import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './AddList.module.scss';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';


import * as actions from 'store/actions/index';
import AddList from 'Flow2/components/AddList/AddList';


class TagCatalogAddList extends React.Component {
    
    componentDidMount() {
		if(!this.props.tags) {
			//this.props.loadTags();
		}
    }
    
    getWords = (ids, words) => {
        return ids.map(id => words[id]);
    }

    // remove not existing ids
    getCleanData = (values, list) => {
		//return values;
        const ids = list.map(item => item.id);
        return values.filter(val => ids.includes(parseInt(val)));
    }
    
    render = () => {
         // sort by name
        const sortByName = (a, b) => {
            const nameA = a.word.toUpperCase(); // ignore upper and lowercase
            const nameB = b.word.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        };
        
        const values = (this.props.data && this.props.data.split(';')) || [];
        const list = Object.values(this.props.tags).sort(sortByName);
        const data = this.getCleanData(values, list);//values;
        const words = {};
        
        list.forEach(item => {
            item.combined = item.word+" ("+item.cat+")";
            words[item.id+""] = item.word;
        });
        
        const add = (input) => {
            if (input && data.indexOf(input) === -1) {
                data.unshift(input);
                const obj = { ids: data.join(';'), words: this.getWords(data, words) };
                this.props.add(obj);
            }
        }
        
        const remove = (index) => {
            let elm = data.splice(index, 1);
            const obj = { ids: data.join(';'), words: this.getWords(data, words) };
            this.props.remove(obj);
        }
        
        return (
            <AddList
                key={this.props.key}
                data={data}
                list={list}
                valueField={"id"}
                labelField={"combined"}
                showAll={this.props.showAll}
                hideUntilInput={true}
                add={this.props.add ? add : null}
                remove={this.props.remove ? remove : null}
            />
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        tags: state.tags.tags,
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        //loadTags: () => dispatch(actions.searchTags("",{op:'listall'}))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagCatalogAddList);
